var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shouldHandleDragAndDropToPost)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isHandlingDragEvent),expression:"isHandlingDragEvent"}],ref:"draggingOverlay",class:['fixed', 'inset-0', 'z-dragging-overlay', _vm.backgroundClasses],on:{"dragenter":function($event){$event.preventDefault();return _vm.setupDragEvent.apply(null, arguments)},"dragover":function($event){$event.preventDefault();},"dragleave":function($event){$event.preventDefault();return _vm.stopHandlingDragEvent.apply(null, arguments)},"dragend":function($event){$event.preventDefault();return _vm.stopHandlingDragEvent.apply(null, arguments)},"drop":function($event){$event.preventDefault();return _vm.onDrop.apply(null, arguments)}}},[(!_vm.isAnyDraftActive)?_c('div',{class:[
      'w-[14.375rem]',
      'h-[15.75rem]',
      'absolute',
      'pointer-events-none',
      'inset-0',
      'm-auto',
      'bg-light-ui-100 dark:bg-dark-ui-100',
    ],style:({ maskImage: `url(${_vm.dragAndDropHexagonOutline})`, maskSize: '100% 100%' })},[_c('div',{class:[
        'w-[13.875rem]',
        'h-[15.25rem]',
        'absolute',
        'inset-0',
        'm-auto',
        'flex',
        'items-center',
        'justify-center',
        'bg-grape-500 dark:bg-canary-500',
      ],style:({ maskImage: `url(${_vm.dragAndDropHexagon})`, maskSize: '100% 100%' })},[_c('div',{class:[
          'w-[12rem]',
          'text-input-body',
          'font-sans',
          'text-center',
          'text-light-text-100 dark:text-dark-text-100',
          'break-words',
        ]},[_vm._v("\n        "+_vm._s(_vm.dropActionMessage)+"\n      ")])])]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }